module.exports = __webpack_public_path__ + "static/img/upgrade-prana150-200.fb12966.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/offer/upgrade-prana150-200.jpg
// module id = 55
// module chunks = 1 2